import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './styles/dynamiskside.css';
import LogoSlider from '../components/logoslider';
import heroBg from '../images/image1.jpg'; // Importerer et standardbillede til hero

function DynamiskSide() {
  const { caseId } = useParams();
  const [reference, setReference] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReference = async () => {
      try {
        setLoading(true);
        const referenceDoc = doc(db, 'references', caseId);
        const docSnap = await getDoc(referenceDoc);
        
        if (docSnap.exists()) {
          setReference({ id: docSnap.id, ...docSnap.data() });
        } else {
          setError('Referencen blev ikke fundet');
        }
      } catch (err) {
        console.error("Fejl ved hentning af reference:", err);
        setError('Der opstod en fejl ved hentning af reference-data');
      } finally {
        setLoading(false);
      }
    };

    if (caseId) {
      fetchReference();
    }
  }, [caseId]);

  if (loading) {
    return (
      <div className="dynamisk-side loading">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Indlæser reference...</p>
        </div>
      </div>
    );
  }

  if (error || !reference) {
    return (
      <div className="dynamisk-side error">
        <div className="error-container">
          <h2>Ups!</h2>
          <p>{error || 'Referencen kunne ikke findes'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dynamisk-side">
      <div className="case-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="case-hero-overlay"></div>
        <div className="case-hero-content">
          {reference.logoUrl && (
            <div className="case-logo">
              <img src={reference.logoUrl} alt={`${reference.title} logo`} />
            </div>
          )}
          <h1 className="case-title">{reference.title}</h1>
        </div>
      </div>

      <div className="case-content">
        <div className="case-description-section">
          <div className="case-description-container">
            <p className="case-description">{reference.description}</p>
            
            {(reference.cvr || reference.website) && (
              <div className="firma-info">
                {reference.cvr && <p>CVR: {reference.cvr}</p>}
                
                {reference.website && (
                  <p>
                    Hjemmeside: 
                    <a 
                      href={reference.website.startsWith('http') ? reference.website : `https://${reference.website}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      {reference.website}
                    </a>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <LogoSlider />
    </div>
  );
}

export default DynamiskSide;
